<template>
  <div>
    <iframe
      :src="pdfDataUrl"
      width="100%"
      height="900px"
      style="border: none"
      v-if="boletim.documento"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    boletim: {
      type: Object,
    },
  },
  computed: {
    pdfDataUrl() {
      return `data:application/pdf;base64,${this.boletim.documento}#zoom=100`;
    },
  },
};
</script>
